import React from 'react'
import PropTypes from 'prop-types'
import { useViewportSize } from '../../modules/hooks/viewport'
import Typography from '../../components/Basics/Typography'
import { Grid, Root, WhatsAppButton } from './ContactContent.styles'

const WhatsAppIcon = ({ height, width }) => (
  <svg fill="white" height={height} viewBox="0 0 448 512" width={width} xmlns="http://www.w3.org/2000/svg">
    <path d="M380.9 97.1C339 55.1 283.2 32 224.1 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L2 480l117.7-30.9c32.4 17.7 68.9 27 106.4 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-69.4-157zm-156.8 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-70 18.4 18.7-68.2-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.5 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.6-9.7-1.5-2.8-13.4-32.3-18.3-44.2-4.8-11.6-9.7-10-13.3-10.2-3.4-.2-7.3-.2-11.2-.2-3.9 0-10.2 1.5-15.6 7.2-5.4 5.7-20.6 20.2-20.6 49.3 0 29 21.1 57 24 61 2.9 4 39.8 63.5 98.7 86.5 46.6 18.1 62.9 15.4 74.7 13.2 12.5-2.3 32.8-13.6 37.4-26.7 4.6-13.1 4.6-24.4 3.1-26.9-1.4-2.7-5.1-4.1-10.7-6.9z" />
  </svg>
)

WhatsAppIcon.propTypes = {
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired
}

/**
 * The Contact Content' container.
 */
const ContactContent = () => {
  const { isTiny } = useViewportSize()

  return (
    <>
      <Root>
        <Grid
          container
          alignItems="center"
          direction="row"
          height={isTiny ? 'auto' : '80vh'}
          justify="space-evenly"
          padding={isTiny ? '40px 0' : '0'}
        >
          {/* DATA CONTACT */}
          <Grid item xs={10} md={3}>
            <Grid container alignItems="center" direction="row" justify="center">
              <Grid item xs={10}>
                <Typography color="white" margin="1em 5px 50px" variant="body2">
                  Si tienes dudas, necesitas asistencia técnica o quieres darnos tu opinión, contáctanos.
                </Typography>
              </Grid>
            </Grid>
            <Grid container alignItems="center" direction="row" justify="flex-start">
              <Grid item xs={3} textAlign="center">
                <img src="/assets/icons/mail-icon.svg" alt="Email" />
              </Grid>
              <Grid item xs={9}>
                <Typography color="white" margin="0 5px 5px" variant="body2">
                  EMAIL
                </Typography>
                <a href="mailto:cosmos@cosmosenergy.ai" style={{ textDecoration: 'none' }}>
                  <Typography color="white" fontWeight="bold" margin="0 2px 2px" variant="body2">
                    cosmos@cosmosenergy.ai
                  </Typography>
                </a>
              </Grid>
            </Grid>
            <Grid container alignItems="center" direction="row" justify="flex-start" margin="30px 0 0">
              <Grid item xs={3} textAlign="center">
                <WhatsAppIcon height="28" width="28" />
              </Grid>
              <Grid item xs={9}>
                <Typography color="white" margin="0 5px 12px" variant="body2">
                  WHATSAPP
                </Typography>
                <WhatsAppButton
                  href="https://chat.whatsapp.com/BaWFfOeI2R2J4PhuJuxww3?mode=gi_t"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <WhatsAppIcon height="18" width="18" />
                  <Typography color="white" fontWeight="bold" variant="body2">
                    Chatea con nosotros
                  </Typography>
                </WhatsAppButton>
                <Typography color="white" fontSize="12px" margin="8px 2px 2px" variant="body2">
                  Lunes a Viernes: 08:00 a 18:00 hrs
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Root>
    </>
  )
}

export default ContactContent
